'use strict';

angular.module('clientDashboardApp').directive('shareThis',['$location', function ($location) {
    return {
        restrict: 'E',
        scope: {
            url: '=',
            text: '=',
            image: '='
        },
        replace: false,
        template: '<div style="height: 16px;width:16px;"></div>',
        link: function (scope, element, attrs) {
            scope.$watch("url", function(old, newValue) {
                $(element).empty();


                var shareThisOptions = {
                  "service": "sharethis",
                  "hashAddressBar": false,
                  "element": element[0],
                  "url": scope.url,
                  "title": attrs.title,
                  "type": (attrs.sharetype ? attrs.sharetype : "chicklet"),
                  "summary": scope.text
                };

                if(angular.isDefined(scope.image)){
                  shareThisOptions.image = scope.image;
                }
                stWidget.addEntry(shareThisOptions);
            });

        }
    };
}]);
